/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-send': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.156 9.444L3.406 2.569a.625.625 0 00-.675.075.625.625 0 00-.206.625L4.375 10 2.5 16.712a.625.625 0 00.625.788.625.625 0 00.281-.069l13.75-6.875a.625.625 0 000-1.112zm-13.062 6.25l1.381-5.069h5.775v-1.25H5.475L4.094 4.306 15.475 10 4.094 15.694z"/>'
  }
})
